const whatsAppUrlBase = 'https://api.whatsapp.com/send';
const number = '554740072374';
const message =
  'Oi%2C%20estou%20no%20App%20EQI%2B%20e%20gostaria%20de%20ajuda.';

export const appConfig = {
  appURL: process.env.NEXT_PUBLIC_APP_URL ?? '',
  description:
    'EQI+ - Plataforma completa controle e personalize seus investimentos, research notícias e mais',
  facebookDomainKey: process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_KEY ?? '',
  financialPlanningURL: 'https://fp.eqi.com.br/auth',
  getMyCreditCard:
    'https://invistamonett.eqi.com.br/?utm_campaign=AAAAMMDD-CPT-AON--X&utm_source=MNT--XXX&utm_medium=DTA-XXX-XXX&utm_content=OUT-ACC&campaignId=7014V000002XueWQAS',
  googleSafeBrowsing:
    'https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fmonett.app&hl=pt_BR',
  gtmID: process.env.NEXT_PUBLIC_GTM_ID ?? '',
  institutionalNumber: '556192487928',
  isProduction: process.env.NODE_ENV === 'production',
  lifeInsuranceYoutubeURL:
    'https://www.youtube.com/embed/V__jJLGRico?si=htiPwVbc2ey9kkb_',
  name: 'EQI+',
  recaptchaKey: process.env.NEXT_PUBLIC_RECAPTCHA_KEY ?? '',
  scheme: 'eqimaisapp://',
  simulatePrivatePensionContactNumber: '554789190726',
  siteName: 'EQI+',
  support: {
    whatsAppLink: `${whatsAppUrlBase}?phone=${number}&text=${message}`,
    whatsAppUrlBase,
    number,
    message,
  },
  oneSignal: {
    appId: process.env.NEXT_PUBLIC_ONESIGNAL_APPID ?? '',
    safariWebId: process.env.NEXT_PUBLIC_ONESIGNAL_SAFARIWEBID ?? '',
  },
};
